// api
import ModelService from '@/services/model.service'
import { mapState } from 'vuex'

export default {
  name: 'Gallery',
  data() {
    return {
      // 英语 中文 越南语 柬埔寨语 印尼语
      adIdList: [14, 26, 51, 69, 86],
      // data
      swiperOption: {
        slidesPerView: 'auto',
        freeMode: true,
        mousewheel: true,
      },
      pictureInfo: '', // 大图数据
      curgalleryName: '', // 当前相册名称
      curgalleryThrName: '', // 三级目录名
      curgalleryFourName: '', // 四级目录名
      selectBarStatus: false,
      pictureStatus: false, // 弹层
      albumStatus: false, // 照片列表
      swiperSlides: '',
      factoryList: '',
      gallerySecList: '',
      galleryList: '',
      curFactory: '',
      curgallerySec: '',
      curgalleryThr: '',
      myPlayer: '',
      pageName: '',
      pageName_cn: {
        select: '请选择工厂',
        nopic: '暂无照片',
      },
      pageName_en: {
        select: 'Please select the factory',
        nopic: 'no picture',
      },
    };
  },
  computed: mapState({
    ...mapState(['isPC', 'language', 'LangIndex'])
  }),
  watch: {
    LangIndex: {
      handler(str) {
        this.init();
      },
    },
  },
  beforeRouteUpdate(to, from, next){
    // console.log(to.params.factoryName);
    next();
    this.init();
  },
  mounted() {
    console.log('params: ', this.$route.params);
    console.log('query: ', this.$route.query);
    this.init();
  },
  methods: {
    init() {
      this.getAdPictureList();
      this.getFactoryList();
      this.initVideo();
      this.initLang();
    },
    initLang() {
      if (this.LangIndex === 1) {
        this.pageName = this.pageName_cn;
      } else {
        this.pageName = this.pageName_en;
      };
    },
    // 获取所有一级相册列表
    getFactoryList() {
      const language = {
        lang: this.language,
        id: 0
      };
      ModelService.getgalleryList(language).then((res) => {
        if (res.code === 0) {
          const data = res.data;
          this.factoryList = data;
          const curFactoryName = this.$route.params.factoryName;
          if (curFactoryName === 'Management') {
            this.curFactory = data.filter(item => (item.id === 3))[0];
          } else {
            this.curFactory = data.filter(item => (item.name === curFactoryName))[0];
          };
          this.getGallerySecList();
        }
      });
    },
    // 获取所有二级相册列表
    getGallerySecList() {
      const language = {
        lang: this.language,
        id: this.curFactory.id
      };
      ModelService.getgalleryList(language).then((res) => {
        if (res.code === 0) {
          const data = this.evenTwo(res.data);
          this.gallerySecList = data;
          const curSecName = this.$route.query.sid;
          if (curSecName) {
            this.curgallerySec = this.equal(data, curSecName)[0];
            this.getGalleryThrList(true);
          } else {
            this.curgallerySec = data[0];
            this.getGalleryThrList();
          };
          // console.log('getGallerySecList: ', data);
        }
      });
    },
    // 获取所有二级相册内照片列表 || 三级相册列表
    getGalleryThrList(status) {
      const language = {
        lang: this.language,
        id: this.curgallerySec.id
      };
      ModelService.getgalleryList(language).then((res) => {
        if (res.code === 0) {
          const newData = this.evenTwo(res.data);
          if (newData[0] && newData[0].type === 'directory') {
            const data = this.evenFour(newData);
            const curThrName = this.$route.query.tid;
            const curFourName = this.$route.query.gid;
            if (curThrName && status) {
              const curGallery = this.equal(data, curThrName)[0];
              if (curFourName) {
                // 百日专案四级目录专用
                this.getFourCatalog(curGallery);
              } else {
                this.getGalleryFourList(curGallery);
              }
            } else {
              this.galleryList = data;
            };
          } else {
            this.curgalleryName = this.curgallerySec.name;
            const data = this.evenTwo(newData);
            this.galleryList = data;
            // 手动点击二级目录 打开照片列表弹层
            if (this.isPC) {
              this.albumStatus = true;
            }
            // console.log('getGalleryThrList: ', data);
          }
        }
      });
    },
    // 百日专案四级目录专用
    getFourCatalog(item) {
      const language = {
        lang: this.language,
        id: item.id
      };
      ModelService.getgalleryList(language).then((res) => {
        if (res.code === 0) {
          const newData = this.evenTwo(res.data);
          if (newData[0] && newData[0].type === 'directory') {
            const data = this.evenFour(newData);
            const curFourName = this.$route.query.gid;
            if (curFourName) {
              const curGallery = this.equal(data, curFourName)[0];
              this.curgalleryThr = item;
              this.curgalleryThrName = item.name;
              this.getGalleryFourList(curGallery);
            }
          }
          // console.log('getgalleryInfo: ', this.galleryList);
        }
      });      
    },
    // 获取四级相册-照片列表
    getGalleryFourList(item, status) {
      const language = {
        lang: this.language,
        id: item.id
      };
      ModelService.getgalleryList(language).then((res) => {
        if (res.code === 0) {
          const newData = this.evenTwo(res.data);
          if (!status) {
            if (this.curgalleryThrName) {
              this.curgalleryFourName = item.name;
            } else {
              this.curgalleryThr = item;
              this.curgalleryThrName = item.name;
            };
          }
          this.curgalleryName = item.name;
          this.galleryList = newData;

          if (newData[0] && newData[0].type === 'directory') {
            this.albumStatus = false;
          } else {
            this.albumStatus = true;
          }
          // console.log('getgalleryInfo: ', this.galleryList);
        }
      });
    },
    // 根据id获取广告图片
    getAdPictureList() {
      const param = {
        lang: this.language,
        adId: this.adIdList[this.LangIndex],
      };
      ModelService.getbanner(param).then((res) => {
        if (res.code === 0) {
          this.swiperSlides = res.data[0];
        }
      });
    },
    // 数据过滤
    equal(numbers, target) {
      return numbers.filter( (number) => {
        return number.id === Number(target)
      })
    },
    // 数据过滤
    even(numbers) {
      return numbers.filter(function (number) {
        return number.id !== 3
      })
    },
    // 数据过滤
    evenTwo(numbers) {
      return numbers.filter(function (number) {
        return number.name !== '..'
      })
    },
    // 数据过滤
    evenThr(numbers) {
      return numbers.filter(function (number) {
        return number.type !== 'directory'
      })
    },
    // 数据过滤
    evenFour(numbers) {
      return numbers.filter(function (number) {
        return number.type === 'directory'
      })
    },
    // 选择工厂
    checkFactory(index) {
      this.curgalleryThrName = '';
      this.curgalleryFourName = '';
      this.curFactory = this.factoryList[index];
      this.$tools.go({
        name: 'Gallery',
        params: {
          factoryName: this.curFactory.name,
        },
      });
    },
    // 切换二级目录
    switchGallery(data) {
      this.curgalleryThrName = '';
      this.curgalleryFourName = '';
      this.curgallerySec = data;
      this.albumStatus = false;
      this.getGalleryThrList(false);
    },
    // 打开图片弹层
    openPicturePopup(data) {
      this.pictureInfo = data;
      if (data.type === 'video') {
        this.openVideoPopup();
      }
      this.showPicturePopup();
    },
    // 打开视频弹层
    openVideoPopup() {
      this.myPlayer.src(this.pictureInfo.url);  //重置video的src
      this.myPlayer.poster(this.pictureInfo.preview);  //重置video的poster
      this.myPlayer.load(this.pictureInfo.url);  //使video重新加载
    },
    // mobile返回相册列表
    backAlbumList() {
      if (this.curgalleryFourName) {
        this.curgalleryFourName = '';
        const curData = this.curgalleryThr;
        this.getGalleryFourList(curData, true);
      } else {
        this.curgalleryThrName = '';
        this.getGalleryThrList(false);
      };
      this.albumStatus = false;
    },
    // pc 返回三级目录
    backThreeAlbumList() {
      this.curgalleryThrName = '';
      this.curgalleryFourName = '';
      this.getGalleryThrList(false);
    },
    // pc 返回四级目录
    backFourAlbumList() {
      this.curgalleryFourName = '';
      const curData = this.curgalleryThr;
      this.getGalleryFourList(curData, true);
    },
    // 视频初始化
    initVideo() {
      //初始化视频方法
      this.myPlayer = this.$video(galleryVideo, {
        //确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
        posterImage: true,
        loop: true,
        controls: true,
        //自动播放属性,muted:静音播放
        autoplay: false,
        //建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
        preload: "auto",
        //设置视频播放器的显示宽度（以像素为单位）
        width: "1200px",
        //设置视频播放器的显示高度（以像素为单位）
        height: "400px",
        sources: [{
          src: this.pictureInfo.url || 'http://qycz-1.oss-cn-shenzhen.aliyuncs.com/rongcheng/videos/2019-03-22/3c975abe60384194b862d0405f3d0b27.mp4',
          type: 'video/mp4'
        }],
      });
      console.log('video init over!')
    },
    openFactoryPopup() {
      this.selectBarStatus = true;
    },
    closeFactoryPopup() {
      this.selectBarStatus = false;
    },
    showPicturePopup() {
      this.pictureStatus = true;
    },
    hidePicturePopup() {
      if (this.pictureInfo.type === 'video') {
        this.myPlayer.pause();
      };
      this.pictureStatus = false;
    },
  },
};
